/**
 * Social media profiles configuration
 * Used for SEO, structured data and consistent display across the site
 */

export interface SocialProfile {
  name: string;
  url: string;
  handle: string;
  icon: string;
  active: boolean;
}

// Social media profiles
export const socialProfiles: SocialProfile[] = [
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/bemoi/',
    handle: 'georgebemoi',
    icon: 'in',
    active: true
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com/bemoi',
    handle: '@BemoiGeorge',
    icon: 'tw',
    active: true
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/bemoig/',
    handle: '@bemoi.george',
    icon: 'ig',
    active: true
  },
  {
    name: 'GitHub',
    url: 'https://github.com/skillshiftdigital',
    handle: 'skillshiftdigital',
    icon: 'gh',
    active: true
  }
];

/**
 * Get all active social profiles
 */
export const getActiveSocialProfiles = (): SocialProfile[] => {
  return socialProfiles.filter(profile => profile.active);
};

/**
 * Get profile URLs for structured data
 */
export const getSocialProfileUrls = (): string[] => {
  return getActiveSocialProfiles().map(profile => profile.url);
};

/**
 * Get social profile by name
 */
export const getSocialProfileByName = (name: string): SocialProfile | undefined => {
  return socialProfiles.find(profile => 
    profile.name.toLowerCase() === name.toLowerCase()
  );
};